// @flow
import * as segment from "./segment";

export default segment;
